import { render, staticRenderFns } from "./FormGroupThuxHorizontal.vue?vue&type=template&id=df56e172&"
import script from "./FormGroupThuxHorizontal.vue?vue&type=script&lang=js&"
export * from "./FormGroupThuxHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports